module.exports = __webpack_public_path__ + "static/media/Apple iPhone XR Red.3b9fee00.png";